/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type GlobalPermissionsPageQuery,
} from './ui/__generated__/GlobalPermissionsPageQuery.graphql';

type GlobalPermissionsEntryPointComponent = EntryPointComponent<
	{
		globalPermissionsPageQuery: GlobalPermissionsPageQuery;
	},
	{},
	{},
	{}
>;

export const globalPermissionsEntryPoint: EntryPoint<
	GlobalPermissionsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalPermissionsEntryPointComponent>(
		/* webpackChunkName: "async-global-permissions" */ './ui/GlobalPermissionsPage.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			globalPermissionsPageQuery: {
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
